import axios from 'axios';

const apiService = axios.create({
  baseURL: process.env.PUBLIC_URL,
});

apiService.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    config.headers['x-auth-token'] = token;
  }
  const recaptchaToken = localStorage.getItem('recaptcha_token');
  if (recaptchaToken && config.headers) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }
  return config;
});

apiService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log('call the refresh token api here');
      // Handle 401 error, e.g., redirect to login or refresh token
    }
    return Promise.reject(error);
  },
);

export default apiService;
